export const getData = (key, defaultValue = null) => {
    try {
        const serializedState = localStorage.getItem(key);
        if (serializedState === null) {
            return defaultValue;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return defaultValue;
    }
};

export const setData = (key, data = null) => {
    if (data === null) {
        return;
    }

    if (typeof data === 'object') {
        data = JSON.stringify(data);
    }

    localStorage.setItem(key, data);
};

export const setDataIfDifferent = (key, data = null) => {
    if (data === null) {
        return;
    }

    try {
        const serializedState = localStorage.getItem(key);
        if (serializedState === null) {
            setItem(key, data);
            return;
        }

        if(!_.isEqual(data, JSON.parse(serializedState))) {
            setItem(key, data);
        }
        
    } catch (err) {
        return;
    }   
};

function setItem (key, data) {
    if (typeof data === 'object') {
        data = JSON.stringify(data);
    }

    localStorage.setItem(key, data);
}